const subscription = {
    limit_exceeded: 'Você atingiu o limite do seu plano de assinatura.',
    get_plan_failed: 'Não foi possível obter o plano de assinatura para o inquilino.',
    tenant_suspended: 'O inquilino está suspenso. Por favor, entre em contato com o administrador.',
};
export default Object.freeze(subscription);
